import React from "react";
import { Card, Form, Checkbox, Divider, Button, InputNumber, Col, Row, Modal, Input, message } from 'antd';

import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import {NHModal, NHConfirm} from '../../common/NHModal';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const basicUrl = "/yxxc/";
const hjdm = "GD007_1";   //环节代码 

 
/**
 * 军训服装-展示学生填写信息
 */
class Jxfzcmxx extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            blzt: true,        //是否可编辑
            studentData: {},
            initPOvalue: {
                nd: '',
                xsid: '',
                fzcm: '',
                fzcmmc: '',
                xm: '',
                xmmc: '',
                sg: '',
                tz: '',
                bz: '',
            }, 
            autoLchjData:props.lchjData ? props.lchjData : {},   //自动办理流程环节信息
        }
    }

    //渲染前获取  
    componentDidMount() {  
        this.getFzpo();   
        const { location } = this.props;
        const { search } = location;
        let params = decodeURIComponent(search);
        this.initAutoHandleData(params);
    } 

    componentWillReceiveProps(nextProps) {
        //环节办理状态 
        if ('hjblztData' in nextProps) { 
            const hjblztData = nextProps.hjblztData;
            if(hjblztData.hjdm==='GD007_1'){ 
                if (hjblztData) {
                    let blzt = hjblztData.blzt !== '1';
                    this.setState({  hjblztData: hjblztData,blzt: blzt },()=>{ 
                    });
                } else {
                    this.setState({  hjblztData: hjblztData,blzt: true },()=>{ 
                    });
                }
            }
        }
        if ('studentData' in nextProps) { 
             this.getFzpo(nextProps.studentData.XSID);  
        }
    }
   
      getFzpo(fxsid) { 
        let { xsid } = this.props.studentData;
        if(fxsid){
            xsid =fxsid
        }
        NHFetch(basicUrl + "getFzpoByXsidAndNd", "GET", { xsid: xsid })
            .then(res => {
                if (res) {
                    if (res.data) { 
                        this.setState({ initPOvalue: res.data }) 
                    }
                }
            });
    } 

    //初始化自动办理环节数据
    initAutoHandleData =(params)=>{
        const { lchjData={} } = this.props;
        if (Object.keys(lchjData).length == 0){
            NHFetch(basicUrl+'initAutoHandleData'+params,'GET').then(res =>{
                if (res && res.data){
                    this.setState({
                        autoLchjData:res.data['lchjData'] ? res.data['lchjData'] : {},
                        autoHjywxData: res.data['hjywxData'] ? res.data['hjywxData'] : []
                    })
                } else {
                    message.error("获取自动办理环节初始化数据失败")
                }
            })
        }
    }
    
    handleSubmit = () => {
        const { pkid, hjdm } = this.state.hjblztData;
        const { xsid } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid,  yhbh: userId, hjdm: hjdm };
        this.setState({ loading: true });

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }
 
        this.setState({ loading: true });
        NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data == '1') {
                        message.success('环节办理成功！');
                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                        this.setState({ loading: false });
                    } else {
                        message.error('环节办理失败，请重试！');
                        this.setState({ loading: false });
                    }
                }
                this.setState({ loading: false });
            }).catch((ress) => {
                this.setState({ loading: false });
            })
    };

    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : ''; 
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId,  lchjid: pkid };

        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                            this.setState({ loading: false });
                        } else {
                            message.error('环节办理取消失败，请重试！');
                            this.setState({ loading: false });
                        }
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })
        }, "warn");
    }


    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }
    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

      //自动办理
      onAutoHandle =() =>{
        let {lchjData = {} } = this.props;  
        const { autoLchjData } = this.state;
        this.props.onAutoHandle(autoLchjData); 
    }

    render() {

        const { form,lchjData = {}, hasLast, hasNext ,autoHandle} = this.props;
        const { blzt, lstdBlyy, show, lstdData, yjje, loading, previewVisible, previewImage, dkyhmc ,initPOvalue,autoLchjData} = this.state;
        let { xsid } = this.props.studentData;
        const { sfdybdd = '0' } = lchjData; //是否打印报到单
       const formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 8 },
            }
        }

        return (
            <div>
                  <Card type="inner" title="军训服装信息">
                    { 
                            <div>
                                <Form>
                                    <FormItem {...formItemLayout} label={'身高'}>
                                        <span>{initPOvalue.sg}cm</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'体重'}>
                                        <span>{initPOvalue.tz}kg</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'鞋码'}>
                                        <span>{initPOvalue.xmmc}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'服装尺码'}>
                                        <span>{initPOvalue.fzcmmc}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'备注'}>
                                        <span>{initPOvalue.bz}</span>
                                    </FormItem> 
                                </Form> 
                            </div>
                    }
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                { autoHandle == false?
                    blzt  ?
                        <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button>
                        : <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                    :null}
                {
                    sfdybdd == '1' && autoHandle == false? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                { 
                    autoHandle == false && !xsid ? <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.onAutoHandle}>自动办理</Button> :null
                     
                }
                {
                    hasLast && autoHandle == false ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext && autoHandle == false ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
 
        )
    }
}

Jxfzcmxx.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}
 
export default Jxfzcmxx;


// WEBPACK FOOTER //
// ./components/yxxc/steps/jxfzcmxx.js